module.exports = __webpack_public_path__ + "img/户部寨镇-c.04aea096.png";